(function($, window) {

	let win = $(window);
	win.on("load", () => {
		// focus search-form input when hover form
		$('.search-form').on('mouseenter click', function(e) {
			if (!$("input", this).first().val()) {
				e.preventDefault();
			}
			$("input", this).first().focus();
		});
	});
})(jQuery, window);